import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import i18n from './i18n'

Vue.use(Vuetify, {
    theme: {
        options: {
            customProperties: true,
        },
        primary: '#d28218',
        secondary: '#5c5c5c',
        background: '#f8f8f8',
        background2: '#e6e6e6',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    }
});
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    let language = to.params.lang;
    if (!language) {
        language = 'en'
    }
    i18n.locale = language;
    next()
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
